module.exports = __webpack_public_path__ + "img/home-icon-event.6ae31b3b.png";